<template>
  <select
    :name="name"
    v-model="inputValue"
    class="select-box"
  >
    <option v-if="dataType === 'time'" value=""></option>
    <option
      v-for="(item, index) in formSetting"
      :key="index"
      :value="setValue(item)"
    >{{ item.label || setLabel(item) }}</option>
  </select>
</template>

<script>
export default {
  name: "SelectBox",
  props: {
    name: {
      type: String,
      default: ''
    },
    // イレギュラーな処理に対応する時に使用
    dataType: {
      type: String,
      default: ''
    },
    // 設定データ
    formSetting: {
      type: Array | Number
    },
    // ユーザーが入力したデータ
    inputedData: {
      type: Number | String
    }
  },
  computed: {
    /**
     * データバインディングした値
     */
    inputValue: {
      get () {
        return this.inputedData
      },
      set (value) {
        this.$emit('change', value)
      }
    },
  },
  methods: {
    /**
     * 設定する値
     * @return {Number | String} 
     */
    setValue (item) {
      let value = typeof(item.value) === 'string' ? item.value : item
      // 時間の場合 00 のデータも欲しいので -1 して2桁にする
      if (this.dataType === 'time') {
        value = this.make2digits(value - 1)
      }
      // 生年月日の場合 2桁にする
      if (this.dataType === 'birth' && value < 10) {
        value = this.make2digits(value)
      }
      return value
    },
    /**
     * 設定するラベル（テキスト）
     * @return {Number | String} 
     */
    setLabel (item) {
      let label = typeof(item.value) === 'string' ? item.value : item
      // 時間の場合 00 のデータも欲しいので -1 して2桁にする
      if (this.dataType === 'time') {
        label = this.make2digits(label - 1)
      }
      return label
    },
    /**
     * 先頭に0の付いた、2桁の文字に変換
     * @return {String} ex). 1 => 01, 33 => 33, 0 => 00
     */
    make2digits (value) {
      return ('0' + value).slice(-2)
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.select-box {
  appearance: none;
  min-width: 32%;
  padding: 11px 30px 11px 13px;
  border: 1px solid $col_temp_gray3;
  border-radius: 5px;
  font-size: 14px;
  background: url('/static/img/icons/ic_disclosure.svg') no-repeat 90% 50%;
  background-position: right 8px top 50%;
  outline: none;
  &::placeholder {
    color: $col_temp_gray3;
  }
  &::-ms-expand {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Favor/SelectBox.vue